import script from "./ChartCompetitividad.vue?vue&type=script&setup=true&lang=js"
export * from "./ChartCompetitividad.vue?vue&type=script&setup=true&lang=js"

import "./ChartCompetitividad.vue?vue&type=style&index=0&id=e01aec7e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e01aec7e"]])

export default __exports__